<template>
	<div class="login-box">
		<div class="form">
			<Icon class="close-icon" type="md-close" size="34" @click="closeLogin" />
			<div class="form-box">
				<p>团体登录</p>
				<Input v-model="username" style="width: 270px;" placeholder="请输入用户名" />
				<Input v-model="password" style="width: 270px;" placeholder="请输入密码" />
				<div>
					<p>没有账号？去<span @click="register">注册</span></p>
					<p><span @click="changePsd">忘记密码</span></p>
				</div>
				<div class="login-btn" :class="{forbid_click:logining}" @click="login">
					{{logining ? '登录中...' : '登录'}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { checkMailbox, hasContent } from '@/common/js/assist'
	import api_request_team from '@/http/modules/team'
	export default {
		data() {
			return {
				username: '',
				password: '',
				logining: false
			}
		},
		methods: {
			changePsd() {
				this.$store.commit('show_team_login', false);
				this.$router.push('/team/change/psd/2')
			},
			register() {
				this.$store.commit('show_team_login', false);
				this.$router.push('/team/register')
			},
			closeLogin() {
				this.$store.commit('show_team_login', false);
			},
			login() {
				const v = this;
				if(!hasContent(v.username)) {
					v.$Message.warning("请输入账号");
					return false
				}
				if(!hasContent(v.password)) {
					v.$Message.warning("请输入密码");
					return false
				}
				v.logining = true;
				api_request_team.teamLogin(
					v.username,
					v.password
				).then(res => {
					v.$store.commit('show_team_login', false);
					localStorage.setItem('team_login_info', JSON.stringify(res.data));
					v.$store.commit('team_login_info', res.data);
					if(!['index', 'register'].includes(v.$route.name)) {
						window.location.reload()
					} else if(v.$route.name == 'register') {
						v.$router.replace('/team/record/1')
					}
				}).finally(() => {
					v.logining = false
				})
			}
		}
	}
</script>

<style scoped lang="scss">
	@import '@/common/css/var.scss';
	/deep/ .ivu-input {
		&:focus {
			border-color: $base-color;
			box-shadow: none;
		}
		&:hover {
			border-color: $base-color;
		}
	}
	
	.login-box {
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, .6);
		.form {
			width: 998px;
			height: 412px;
			background: url(../../images/team/login_bg.png) no-repeat center center / 998px 412px;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			.close-icon {
				position: absolute;
				top: 20px;
				right: 70px;
				cursor: pointer;
				&:hover {
					color: $base-color;
				}
			}
			.form-box {
				width: 360px;
				float: right;
				margin-right: 100px;
				padding-top: 70px;
				>p {
					color: #444446;
					font-size: 32px;
				}
				/deep/ .ivu-input-wrapper {
					margin-top: 20px;
				}
				div {
					color: #696969;
					font-size: 14px;
					width: 270px;
					overflow: hidden;
					p {
						line-height: 52px;
						&:first-child {
							float: left;
						}
						&:last-child {
							float: right;
						}
						span {
							color: $base-color;
							cursor: pointer;
							&:hover {
								text-decoration: underline;
							}
						}
					}
				}
				.login-btn {
					width: 270px;
					height: 40px;
					background: $base-color;
					color: #fff;
					border-radius: 20px;
					text-align: center;
					line-height: 40px;
					transition: all 0.5s;
					cursor: pointer;
					margin-top: 20px;
					&:active {
						transform: scale(1.05);
					}
				}
				.forbid_click {
					pointer-events: none;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/common/components/teamLogin.vue